import { lazyLoad } from 'utils/loadable';

export const DigitalFiles = lazyLoad(() => import('./index'));
